import { colors } from '~/styles/theme'

const HERO_COLOUR_SCHEME = {
  background: {
    'shell-energy-broadband': '#19A8C9',
    'virgin-media': '#3D3045',
    bt: '#583696',
    default: colors.watermelon,
    ee: '#009C9C',
    plusnet: '#19A8C9',
    sky: '#ECECEC',
    talktalk: '#1E4E9D',
    vodafone: '#BF0000'
  },
  text: {
    'shell-energy-broadband': colors.white,
    'virgin-media': colors.white,
    bt: colors.white,
    default: colors.primary,
    ee: colors.white,
    plusnet: colors.white,
    sky: colors.primary,
    talktalk: colors.white,
    vodafone: colors.white
  }
}

export const getHeroColourScheme = (type, provider) => {
  return HERO_COLOUR_SCHEME[type][provider] ? HERO_COLOUR_SCHEME[type][provider] : HERO_COLOUR_SCHEME[type].default
}

export const getHeroBackgroundColour = ({ p0 } = {}) => p0?.display?.backgroundColor || colors.watermelon
